import * as NavigationMenu from '@radix-ui/react-navigation-menu'
import { useBreadcrumb } from './hooks/useBreadcrumb'
import { BreadcrumbDesktop, BreadcrumbMobile } from './components'

export function Breadcrumb() {
  const breadcrumbItems = useBreadcrumb()

  if (breadcrumbItems.length === 0) return null

  const lastItem = breadcrumbItems[breadcrumbItems.length - 1]
  const previousItems = breadcrumbItems.slice(0, -1)

  return (
    <NavigationMenu.Root className="flex items-center gap-2">
      <NavigationMenu.List className="flex items-center gap-1 min-w-0">
        <BreadcrumbDesktop items={breadcrumbItems} />
        <BreadcrumbMobile previousItems={previousItems} lastItem={lastItem} />
      </NavigationMenu.List>
    </NavigationMenu.Root>
  )
}
